module.exports = __webpack_public_path__ + "static/media/townhouse.2342fa34.svg";